import { useState, useEffect, useRef } from 'react';
import { sanitizeJson } from '../../shared/utils/basic';

const useJsonParser = () => {
    const [input, setInput] = useState('');
    const [data, setData] = useState(null);
    const [error, setError] = useState('');
    const [cursorInfo, setCursorInfo] = useState({ line: 1, column: 1 });
    const [errorPosition, setErrorPosition] = useState(null);
    const textareaRef = useRef(null);

    const handleParse = () => {
        try {
            const parsed = JSON.parse(sanitizeJson(input));
            setData(parsed);
            setError('');
            setErrorPosition(null);
        } catch (e) {
            setData(null);
            setError(e.message);
            const match = e.message.match(/position (\d+)/);
            if (match) {
                const pos = parseInt(match[1], 10);
                setErrorPosition(pos);
            }
        }
    };

    // 1. 모든 상태를 초기화하는 함수를 추가합니다.
    const handleClear = () => {
        setInput('');
        setData(null);
        setError('');
        setCursorInfo({ line: 1, column: 1 });
        setErrorPosition(null);
        // 사용 편의를 위해 텍스트 영역에 자동으로 포커스를 줍니다.
        if (textareaRef.current) {
            textareaRef.current.focus();
        }
    };

    useEffect(() => {
        if (errorPosition !== null && textareaRef.current?.resizableTextArea?.textArea) {
            const realTextarea = textareaRef.current.resizableTextArea.textArea;
            realTextarea.focus();
            realTextarea.setSelectionRange(errorPosition, errorPosition);
        }
    }, [errorPosition]);

    const handleCursorChange = (e) => {
        const position = e.target.selectionStart;
        const lines = input.substring(0, position).split('\n');
        const line = lines.length;
        const column = lines[lines.length - 1].length + 1;
        setCursorInfo({ line, column });
    };

    return {
        input,
        setInput,
        data,
        error,
        cursorInfo,
        textareaRef,
        handleParse,
        handleCursorChange,
        // 2. 새로 만든 함수를 반환 객체에 포함시킵니다.
        handleClear,
    };
};

export default useJsonParser;